import React, { useEffect } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  FormControl,
  FormHelperText,
  Stack,
  ButtonGroup,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../components/MaterialTypography";
import ConfirmationDialog from "../components/Dialog/ConfirmationDialog";
import MaterialBox from "../components/MaterialBox";
import MaterialInput from "../components/MaterialInput";
import BASEURL from "../pages/Utils/Baseurl";
import { useState } from "react";
import MaterialButton from "../components/MaterialButton";
import axios from "axios";
import DashboardLayout from "../layoutcontainers/DashboardLayout";
import SelectPlaceholder from "./Selecttool";
import MaterialSelect from "../components/MasterSelect";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useUserDetails } from "../context/auth";
import { ApolloClient, InMemoryCache } from '@apollo/client';
import { createUploadLink } from 'apollo-upload-client';
import { gql } from '@apollo/client';
import FileUpload from "../pages/Utils/FileUpload";
function Sourcing() {
  const [source, setsource] = useState({
    department: "",
    jobid: "",
    candidatename: "",
    source: "",
    mobile: "",
    emailid: "",
    jobidStatus: "unchecked",
    candidatenameStatus: "unchecked",
    sourceStatus: "unchecked",
    mobileStatus: "unchecked",
    emailidStatus: "unchecked",
    departmentStatus: "unchecked",
  });

  const[fileupload,setfileupload] = useState(null)
  const[originalfileupload,setoriginalfileupload] = useState(null)
  

  const [OriginalSource, setOriginalSource] = useState({
    department: "",
    jobid: "",
    candidatename: "",
    source: "",
    mobile: "",
    emailid: "",
    jobidStatus: "unchecked",
    candidatenameStatus: "unchecked",
    sourceStatus: "unchecked",
    mobileStatus: "unchecked",
    emailidStatus: "unchecked",
    departmentStatus: "unchecked",

  });


  const uploadLink = createUploadLink({ uri: BASEURL });
  const client = new ApolloClient({
    link: uploadLink,
    cache: new InMemoryCache(),
  });
  
  const navigate = useNavigate();
  const { AccessData } = useUserDetails();

  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const jobidlist = [
    { value: "DFG4566", label: "DFG4566" },
    { value: "DFGBNN", label: "DFGBNN" },
  ];
  const [id, setId] = useState(null);
  const [JobId_data, setJobId_data] = useState([]);
  const Source = [
    { value: "LinkedIn", label: "LinkedIn" },
    { value: "Indeed", label: "Indeed" },
    { value: "Company Website", label: "Company Website" },
    { value: "AngelList", label: "AngelList" },
    { value: "GitHub", label: "GitHub" },
    { value: "Upwork", label: "Upwork" },
    { value: "Stack Overflow Careers", label: "Stack Overflow Careers" },
    { value: "Xing", label: "Xing" },
    { value: "Recruitee", label: "Recruitee" },
    { value: "Hiretual", label: "Hiretual" },
    { value: "Monster", label: "Monster" },
    { value: "SimplyHired", label: "SimplyHired" },
    { value: "Toptal", label: "Toptal" },
    { value: "Jobvite", label: "Jobvite" },
    { value: "Workable", label: "Workable" },
    { value: "Recruitment Agency", label: "Recruitment Agency" },
    { value: "Employee referral", label: "Employee referral" },
  ];

  React.useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setId(id);

    if (id) {
      getInitData(id);
    } else {
      // setPageState((prevState) => ({
      //   ...prevState,
      //   loading: false,
      //   state: "default",
      // }));
    }
  }, []);

  useEffect(() => {
    onDepartmentdata();
    onDepartmentSubmit();
  }, []);

  const [departmentnames, setdepartmentnames] = useState([]);
  const [PositionName,SetPositionName] = useState('')
  console.log(PositionName,"pppname");
  
  const onDepartmentdata = async () => {
    const query = `query {
          allDepartment {
              id
              departmentName
              departmentCode
          }
      }`;

    try {
      // setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const departmentList = response.data.data.allDepartment;
      setdepartmentnames(departmentList);
    } catch (error) {
      console.error("ResponseError:", error);
    }
  };
  const [sampledata, setsampledata] = useState([]);
  const onDepartmentSubmit = async () => {
    const query = `query {
    allStaffRequests {
      id
      jobid
      requestDate
      teamName
      teamLeadName
      
      projectName
      startDate
      role
      salaryLpa
      experience
      employmentType
      approvalStatus
      jobStatus
      role
      keySkills
      priority
      noOfPositions
      preference
      interviewPannel
      noOfRounds
      responsiblePerson
      positionStatus
      jd
      justificationForRequest
    }
  }`;

    try {
      // setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      let result = response.data.data.allStaffRequests;
      console.log("resultresult:", result);
      setsampledata(result);
      // settabledata(result)
    } catch (error) {
      console.error("ResponseError:", error);
      // setPageState({ ...pageState, loading: false, error: true, message: error.message });
    }
  };

  const getInitData = async (id) => {
    const query = `query GetSourcingScreeningById($id: ID!) {
  sourcingScreening(id: $id) {
    id
    jobid
    candidateName
    source
    emailid
    mobileNumber
    totalExperience
    relevantExperience
    currentCtc
    expectedCtc
    leadTime
    yearOfPassing
    currentEmployer
    location
    comments
    interviewAvailability
    interviewer
    cvFile
    department
    position
  }
}`;

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      let result = response.data.data.sourcingScreening;

      console.log('getInitData:',result);
      
    

      setsource({
        ...source,
        jobid: { value: result.jobid, label: result.jobid },
        candidatename: result.candidateName,
        source: { value: result.source, label: result.source },
        mobile: result.mobileNumber,
        emailid: result.emailid,
        department: {value:result.department,label:result.department}
      });

      let filedata = `${FileUpload}${result.cvFile}`

      console.log('filedata:',filedata.split('/').pop());
      let Name = filedata.split('/').pop()
      
      setfileupload({
        name: Name
      })

      SetPositionName(result.position)

      setOriginalSource({
        ...OriginalSource,
        jobid: { value: result.jobid, label: result.jobid },
        candidatename: result.candidateName,
        source: { value: result.source, label: result.source },
        mobile: result.mobileNumber,
        emailid: result.emailid,
        department: {value:result.department,label:result.department}

      });

      setoriginalfileupload({
        name: Name
      })

      setTogglePage({
        ...togglePage,
        view: true,
      });
    } catch (error) {
      console.error("ResponseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const fetchjobid = (department) => {
    let filterdata = sampledata.filter(
      (val) => val.teamName == department && val.approvalStatus === "Recruitment in progress"
    );

    console.log('sampledata:',sampledata);
    console.log('filterdata:',filterdata);
    

    const data = filterdata.map((value) => {
      return {
        value: value.jobid,
        label: value.jobid,
      };
    });

    setJobId_data(data);
  };

  const fetchposition = (Jobid)=>{
    
    let filterdata = sampledata.filter(
      (val) => val.jobid == Jobid
    );
    console.log('filterdata:',filterdata[0].role);

    

    SetPositionName(filterdata[0].role||"")
    
  }


  const handleDesignationDatachange = (event, selectEvent) => {
    console.log("selectEvent:", selectEvent, event?.label);
    let sourceState = { ...source };

    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "department") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        fetchjobid(event?.label);
       
        if (lengthRegex.test(event?.label) === true) {
          sourceState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          sourceState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "jobid") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        console.log(event?.value,"jobiddddd");
        
        fetchposition(event?.value)
        if (lengthRegex.test(event?.label) === true) {
          sourceState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          sourceState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "source") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          sourceState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          sourceState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      sourceState[selectEvent.name] = event;
    } else {
      const changeAllowed = true;
      switch (event.target.name) {
        case "candidatename":
          {
            const alphaNumberLengthRegex = new RegExp("^([a-zA-Z ]{1,40})$");
            // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "mobile":
          {
            const alphaNumberLengthRegex = new RegExp("^[0-9]{10}$");
            // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "emailid":
          {
            // const emailRegex = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,3}$/g);
            const emailRegex = /^[\w.-]+@([\w-]+\.)+[a-zA-Z]{3}$/;
            // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');

            if (emailRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      if (changeAllowed) {
        sourceState[event.target.name] = event.target.value;
      }
    }
    setsource(sourceState);
  };

  // const handlefileupload = (e) => {
  //   const uploadedFile = e.target.files[0];
  //   console.log("Selected File:", uploadedFile);
  //   setfileupload(uploadedFile);
  // };

  const handleFileUpload = (files) => {
    if (files.length > 0) {
      const file = files[0];
      if (
        file.type === "application/pdf" ||
        file.type === "application/msword" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ) {
        setfileupload(file); // Update state with the uploaded file
      } else {
        alert("Unsupported file format. Please upload a PDF, DOC, or DOCX file.");
      }
    }
  };

  const handleFileDrop = (e) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    handleFileUpload(files);
  };
  
  

  const handleAddSource = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        handleSubmit();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

//   const handleSubmit = async () => {
//     const query = `mutation($input: SourcingScreeningInput!) {
//   createSourcingScreening(input: $input) {
//     sourcingScreening {
//       id
//       jobid
//       candidateName
//       screeningStatus
//       source
//       mobileNumber
//       emailid
//       cvFile
//       department  
//       position  
//     }
//   }
// }`;

//     const alldata = {
//       jobid: source.jobid?.value,
//       candidateName: source.candidatename,
//       source: source.source?.value,
//       mobileNumber: source.mobile,
//       emailid: source.emailid,
//       department : source.department?.label,
//       position: PositionName
//     };

//     console.log('alldata:',alldata);
    

//     try {
//       const response = await axios.post(BASEURL, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         query,
//         variables: {
//           input: alldata,
//         },
//       });

//       setConfirmationDialog({
//         ...confirmationDialog,
//         open: false,
//       });

//       const finaldata =
//         response.data.data.createSourcingScreening.sourcingScreening;

//         console.log('finaldata:',finaldata);
        

//       if (finaldata !== "") {
//         Swal.fire({
//           position: "center",
//           icon: "success",
//           title: "Sourcing Submitted Successfully!",
//           showConfirmButton: false,
//           timer: 2500,
//         });
//         navigate("/sourcing");
//       }
//     } catch (error) {
//       console.error("responseError:", error.response.data);
//       setConfirmationDialog({
//         open: true,
//         title: "Error message",
//         message:
//           "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
//         showCancel: true,
//         showConfirm: false,
//         onCancel: () => {
//           setConfirmationDialog({
//             ...confirmationDialog,
//             open: false,
//           });
//         },
//       });
//     }
//   };

console.log('fileupload:',fileupload);


const handleSubmit = async () => {
  const query = gql`
    mutation($input: SourcingScreeningInput!) {
      createSourcingScreening(input: $input) {
        sourcingScreening {
          id
          jobid
          candidateName
          screeningStatus
          source
          mobileNumber
          emailid
          cvFile
          department
          position
        }
      }
    }
  `;

  const alldata = {
    jobid: source.jobid?.value || "",
    candidateName: source.candidatename || "",
    source: source.source?.value || "",
    mobileNumber: source.mobile || "",
    emailid: source.emailid || "",
    department: source.department?.label || "",
    position: PositionName || "",
  };

  console.log("Payload:", alldata);

  try {
   
    const variables = {
      input: {
        ...alldata,
        cvFile: fileupload,  
      },
    };

    const response = await client.mutate({
      mutation: query,
      variables: variables,
    });

    const finalData = response.data.createSourcingScreening.sourcingScreening;
    console.log("Response Data:", finalData);

    if (finalData) {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Sourcing Submitted Successfully!",
        showConfirmButton: false,
        timer: 2500,
      });
      navigate("/sourcing");
    }
  } catch (error) {
    console.error("Error:", error.response?.data || error.message);

    setConfirmationDialog({
      open: true,
      title: "Error message",
      message: "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
      showCancel: true,
      showConfirm: false,
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  }
};


  const handleEdit = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to Update your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        UpdateSourcing();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

//   const UpdateSourcing = async () => {
//     const query = `mutation UpdateSourcingScreening($id: ID!, $input: SourcingScreeningInput!) {
//   updateSourcingScreening(id: $id, input: $input) {
//     sourcingScreening {
//       id
//       jobid
//       candidateName
//       source
//       emailid
//       mobileNumber
//       cvFile
//     }
//   }
// }`;

//     const alldata = {
//       jobid: source.jobid?.value,
//       candidateName: source.candidatename,
//       source: source.source?.value,
//       mobileNumber: source.mobile,
//       emailid: source.emailid,
//     };
//     console.log("alldata:", alldata);

//     try {
//       const response = await axios.post(BASEURL, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         query,
//         variables: {
//           id: id,
//           input: alldata,
//         },
//       });

//       setConfirmationDialog({
//         ...confirmationDialog,
//         open: false,
//       });
//       console.log("updateSourcingScreening:", response.data);

//       const finaldata =
//         response.data.data?.sourcingScreening?.sourcingScreening;

//       if (finaldata !== "") {
//         Swal.fire({
//           position: "center",
//           icon: "success",
//           title: "Sourcing Updated Successfully!",
//           showConfirmButton: false,
//           timer: 2500,
//         });
//         navigate("/sourcing");
//       }
//     } catch (error) {
//       console.error("responseError:", error);
//       setConfirmationDialog({
//         open: true,
//         title: "Error message",
//         message:
//           "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
//         showCancel: true,
//         showConfirm: false,
//         onCancel: () => {
//           setConfirmationDialog({
//             ...confirmationDialog,
//             open: false,
//           });
//         },
//       });
//     }
//   };
  

const UpdateSourcing = async () => {
  const query = gql`
    mutation UpdateSourcingScreening($id: ID!, $input: SourcingScreeningInput!) {
      updateSourcingScreening(id: $id, input: $input) {
        sourcingScreening {
          id
          jobid
          candidateName
          source
          emailid
          mobileNumber
          cvFile
        }
      }
    }
  `;

  const alldata = {
    jobid: source.jobid?.value,
    candidateName: source.candidatename,
    source: source.source?.value,
    mobileNumber: source.mobile,
    emailid: source.emailid,
  };
  console.log("alldata:", alldata);

  // Add file upload handling here
  const variables = {
    id: id,  // Ensure this is passed correctly
    input: {
      ...alldata,
      cvFile: fileupload, // Include the fileupload here
    },
  };

  try {
    // Prepare for sending the mutation with the file
    const response = await client.mutate({
      mutation: query,
      variables: variables,
      context: {
        // Add context to indicate the request includes a file upload
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    });

    setConfirmationDialog({
      ...confirmationDialog,
      open: false,
    });
    console.log("updateSourcingScreening:", response.data);

    const finalData = response.data.updateSourcingScreening.sourcingScreening;

    if (finalData) {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Sourcing Updated Successfully!",
        showConfirmButton: false,
        timer: 2500,
      });
      navigate("/sourcing");
    }
  } catch (error) {
    console.error("responseError:", error);
    setConfirmationDialog({
      open: true,
      title: "Error message",
      message:
        "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
      showCancel: true,
      showConfirm: false,
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  }
};

const checkAllFields = () => {
  let allowSubmit = false;
  if (
    // staffrequest.jobidStatus === "success" &&
    source.departmentStatus === "success" &&
    source.jobidStatus === "success" &&
    source.candidatenameStatus === "success" &&
    source.sourceStatus === "success" &&
    source.sourceStatus === "success" &&
    source.emailidStatus === "success" && 
    fileupload
  
  ) {
    allowSubmit = true;
  } else {
    allowSubmit = false;
  }
  return allowSubmit;
};

const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        OnDeleteSourcing();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const OnDeleteSourcing = async () => {
    const query = `
     mutation DeleteSourcingScreening($id: ID!) {
  deleteSourcingScreening(id: $id) {
    success
    message
  }
}
    `;

    try {
      const response = await axios.post(BASEURL, {
        query: query,
        variables: {
          id: id, // Correct variable assignment
        },
      });

      let data = response.data.data.deleteSourcingScreening;

      console.log("data:", data);

      if (data.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Sourcing Deleted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/sourcing");
      }
      // return response.data;
    } catch (error) {
      console.error("Error deleting user:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const handleDiscard = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to discard your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDiscardWfh();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onDiscardWfh = () => {
    setTogglePage({
      view: true,
      edit: false,
    });
    setsource({
      jobid: OriginalSource.jobid,
      candidatename: OriginalSource.candidatename,
      source: OriginalSource.source,
      mobile: OriginalSource.mobile,
      emailid: OriginalSource.emailid,
      department: OriginalSource.department
    });
    setfileupload(originalfileupload)
    setConfirmationDialog({
      ...confirmationDialog,
      open: false,
    });
  };

  const handlecancel = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sue you want to cancel?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onCancelAction(); // Call the function that handles cancel
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
 

  const onCancelAction = ()=>{
    navigate('/sourcing')
  }

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card>
        <CardHeader
          title={
            <>
              {togglePage.view === true || togglePage.edit === true ? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                       Source Details
                    </MaterialTypography>
                  </Stack>
                  {AccessData &&
                    Array.isArray(AccessData) &&
                    AccessData.some(
                      (item) =>
                        item.component === "EditSourcing" && item.can_access
                    ) &&
                    pageState.state !== "submitting" && (
                      <ButtonGroup
                        variant="outlined"
                        aria-label="Loading button group"
                      >
                        <MaterialButton
                          variant="gradient"
                          color="dark"
                          onClick={toggleEdit}
                          startIcon={<EditIcon />}
                        >
                          Edit
                        </MaterialButton>
                        <MaterialButton
                          variant="gradient"
                          color="dark"
                          onClick={AddDelete}
                          startIcon={<DeleteIcon />}
                        >
                          Delete
                        </MaterialButton>
                      </ButtonGroup>
                    )}
                </Stack>
              ) : (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                      Add Source
                    </MaterialTypography>
                  </Stack>
                </Stack>
              )}
            </>
          }
        />
        <CardContent>
          <Grid container spacing={2}>
            <Grid size={{ xs: 5, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Department <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="department"
                value={source.department}
                customStyles={{ optionPadding: 20 }}
                onChange={handleDesignationDatachange} //selectedValue, event
                options={departmentnames?.map((value) => {
                  return {
                    value: value.id,
                    label: value.departmentName,
                  };
                })}
                error={source.departmentStatus === "error" ? true : false}
                success={source.departmentStatus === "success" ? true : false}
                isDisabled={togglePage.view === true ? true : false}
                //   isClearable
              />
              {source.departmentStatus === "error" && (
                <FormControl error>
                  <FormHelperText>Department is Mandatory</FormHelperText>
                </FormControl>
              )}
            </Grid>
            <Grid size={{ xs: 5, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Job ID <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="jobid"
                value={source.jobid}
                customStyles={{ optionPadding: 20 }}
                onChange={handleDesignationDatachange} //selectedValue, event
                options={JobId_data.map((value) => {
                  return {
                    value: value.value,
                    label: value.label,
                  };
                })}
                error={source.jobidStatus === "error" ? true : false}
                success={source.jobidStatus === "success" ? true : false}
                isDisabled={togglePage.view === true ? true : false || source.department === ""}
                //   isClearable
              />
              {source.jobidStatus === "error" && (
                <FormControl error>
                  <FormHelperText>Job ID is Mandatory</FormHelperText>
                </FormControl>
              )}
            </Grid>
            <Grid size={{ xs: 5, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Position 
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="PositionName"
                value={PositionName}
                // customStyles={{ optionPadding: 20 }}
                // onChange={handleDesignationDatachange}
                // error={source.candidatenameStatus === "error" ? true : false}
                // success={
                //   source.candidatenameStatus === "success" ? true : false
                // }
                disabled={true}
                //   isClearable
              />
              {/* {source.candidatenameStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Candidate Name should be a maximum of 40 characters long and
                    can contain only alphabets.
                  </FormHelperText>
                </FormControl>
              )} */}
            </Grid>
            <Grid size={{ xs: 5, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Candidate Name <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="candidatename"
                value={source.candidatename}
                customStyles={{ optionPadding: 20 }}
                onChange={handleDesignationDatachange}
                error={source.candidatenameStatus === "error" ? true : false}
                success={
                  source.candidatenameStatus === "success" ? true : false
                }
                disabled={togglePage.view === true ? true : false}
                //   isClearable
              />
              {source.candidatenameStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Candidate Name should be only alphabets.
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>

            <Grid size={{ xs: 5, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Source <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="source"
                value={source.source}
                customStyles={{ optionPadding: 20 }}
                onChange={handleDesignationDatachange} //selectedValue, event
                options={Source.map((value) => {
                  return {
                    value: value.value,
                    label: value.label,
                  };
                })}
                error={source.sourceStatus === "error" ? true : false}
                success={source.sourceStatus === "success" ? true : false}
                isDisabled={togglePage.view === true ? true : false}
                //   isClearable
              />
              {source.sourceStatus === "error" && (
                <FormControl error>
                  <FormHelperText>Source is Mandatory</FormHelperText>
                </FormControl>
              )}
            </Grid>
            <Grid size={{ xs: 5, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Mobile No <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="mobile"
                value={source.mobile}
                customStyles={{ optionPadding: 20 }}
                onChange={handleDesignationDatachange} //selectedValue, event
                error={source.mobileStatus === "error" ? true : false}
                success={source.mobileStatus === "success" ? true : false}
                disabled={togglePage.view === true ? true : false}
                //   isClearable
              />
              {source.mobileStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Mobile number should be 10 characters long and can contain
                    only numbers.
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>
            <Grid size={{ xs: 5, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Email ID <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="emailid"
                value={source.emailid}
                customStyles={{ optionPadding: 20 }}
                onChange={handleDesignationDatachange}
                error={source.emailidStatus === "error" ? true : false}
                success={source.emailidStatus === "success" ? true : false}
                disabled={togglePage.view === true ? true : false}
                //   isClearable
              />
              {source.emailidStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Please enter a valid email address
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>
            <Grid container spacing={2}>
  <Grid item xs={12} sm={6}>
    <MaterialBox mb={1}>
      <MaterialTypography
        component="label"
        variant="caption"
        fontWeight="bold"
      >
        CV Upload <span style={{ color: "red" }}>*</span>
      </MaterialTypography>
    </MaterialBox>
    <MaterialBox
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      padding="16px"
      border="2px dashed #4caf50"
      borderRadius="8px"
      bgcolor="#e8f5e9"
      textAlign="center"
      onClick={() => document.getElementById("cvUpload").click()}
      onDragOver={(e) => e.preventDefault()}
      onDrop={(e) => handleFileDrop(e)}
      style={{
        cursor: "pointer",
        transition: "border-color 0.3s",
        "&:hover": {
          borderColor: "#388e3c",
        },
      }}
    >
      <MaterialTypography variant="body2" color="textSecondary">
        Drag & drop your CV or click to upload
      </MaterialTypography>
      <MaterialTypography
        variant="caption"
        color="textSecondary"
        style={{ marginTop: "4px" }}
      >
        Supported formats: .pdf, .doc, .docx
      </MaterialTypography>
      <input
        id="cvUpload"
        type="file"
        disabled={togglePage.view === true ? true : false}
        accept=".pdf,.doc,.docx"
        style={{ display: "none" }}
        onChange={(e) => handleFileUpload(e.target.files)}
      />
    </MaterialBox>
    <MaterialBox mt={1}>
      <MaterialTypography
        variant="caption"
        color="primary"
        style={{
          textOverflow: "ellipsis",
          overflow: "hidden",
          whiteSpace: "nowrap",
        }}
      >
        {fileupload ? fileupload.name : "No file selected"}
      </MaterialTypography>
    </MaterialBox>
  </Grid>
</Grid>


          </Grid>
        </CardContent>
        {/* <MaterialBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          <MaterialButton
            sx={{ m: 2 }}
            variant="gradient"
            color="dark"
            //   disabled={!checkAllFields()}
            onClick={handleAddSource}
          >
            Submit
          </MaterialButton>
        </MaterialBox> */}
        <MaterialBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          {togglePage.edit === true ? (
            <>
              <MaterialButton
                variant="gradient"
                color="dark"
                disabled={pageState.state === "submitting"}
                onClick={handleDiscard}
              >
                Discard
              </MaterialButton>
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                disabled={pageState.state === "submitting"}
                onClick={handleEdit}
              >
                update
              </MaterialButton>
            </>
          ) : togglePage.view === false && togglePage.edit === false ? (
            <>
               <MaterialButton
                                     sx={{ m: 2,marginLeft:'2%' }}
                                     variant="gradient"
                                     color="dark"
                                   
                                     onClick={handlecancel}
                                   >
                                     Cancel
                                   </MaterialButton>
              <MaterialButton
                sx={{ m: 3 ,marginLeft:"4px"}}
                variant="gradient"
                color="dark"
                 disabled={
                   !checkAllFields() 
                 }
                onClick={handleAddSource}
              >
                Submit
              </MaterialButton>
           
            </>
          ) : null}
        </MaterialBox>
      </Card>
    </DashboardLayout>
  );
}

export default Sourcing;
